export default {
    en: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    cs: [
        'a',
        'á',
        'b',
        'c',
        'č',
        'd',
        'e',
        'f',
        'g',
        'h',
        'ch',
        'i',
        'í',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'ó',
        'p',
        'q',
        'r',
        'ř',
        's',
        'š',
        't',
        'ť',
        'u',
        'ú',
        'v',
        'w',
        'x',
        'y',
        'z',
        'ž',
    ],
    tr: [
        'a',
        'â',
        'b',
        'c',
        'ç',
        'd',
        'e',
        'f',
        'g',
        'h',
        'ch',
        'i',
        'ı',
        'î',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'ó',
        'ö',
        'p',
        'q',
        'r',
        's',
        'ş',
        't',
        'u',
        'û',
        'ü',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    ru: [
        'а',
        'б',
        'в',
        'г',
        'д',
        'е',
        'ё',
        'ж',
        'з',
        'и',
        'й',
        'к',
        'л',
        'м',
        'н',
        'о',
        'п',
        'р',
        'с',
        'т',
        'у',
        'ф',
        'х',
        'ц',
        'ч',
        'ш',
        'щ',
        'ъ',
        'ы',
        'ь',
        'э',
        'ю',
        'я',
    ],
    ar: [
        'ا',
        'ب',
        'ت',
        'ث',
        'ج',
        'ح',
        'خ',
        'د',
        'ذ',
        'ر',
        'ز',
        'س',
        'ش',
        'ص',
        'ض',
        'ط',
        'ظ',
        'ع',
        'غ',
        'ف',
        'ق',
        'ك',
        'ل',
        'م',
        'ن',
        'ه',
        'و',
        'ي',
    ],
    az: [
        'a',
        'b',
        'c',
        'ç',
        'd',
        'e',
        'ə',
        'f',
        'g',
        'ğ',
        'h',
        'x',
        'i',
        'ı',
        'j',
        'k',
        'q',
        'l',
        'm',
        'n',
        'o',
        'ö',
        'p',
        'r',
        's',
        'ş',
        't',
        'u',
        'ü',
        'v',
        'y',
        'z',
    ],
    bg: [
        'а',
        'б',
        'в',
        'г',
        'д',
        'е',
        'ж',
        'з',
        'и',
        'й',
        'к',
        'л',
        'м',
        'н',
        'о',
        'п',
        'р',
        'с',
        'т',
        'у',
        'ф',
        'х',
        'ц',
        'ч',
        'ш',
        'щ',
        'ъ',
        'ь',
        'ю',
        'я',
    ],
    br: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    bs: [
        'a',
        'b',
        'c',
        'č',
        'ć',
        'd',
        'dž',
        'đ',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'lj',
        'm',
        'n',
        'nj',
        'o',
        'p',
        'r',
        's',
        'š',
        't',
        'u',
        'v',
        'z',
        'ž',
    ],
    ch: [
        'a',
        'ä',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'ö',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'ü',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    da: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'æ',
        'ø',
        'å',
    ],
    de: [
        'a',
        'ä',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'ö',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'ü',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    ee: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        'š',
        't',
        'u',
        'v',
        'w',
        'õ',
        'ä',
        'ö',
        'ü',
        'x',
        'y',
        'z',
        'ž',
    ],
    el: [
        'α',
        'β',
        'γ',
        'δ',
        'ε',
        'ζ',
        'η',
        'θ',
        'ι',
        'κ',
        'λ',
        'μ',
        'ν',
        'ξ',
        'ο',
        'π',
        'ρ',
        'σ',
        'τ',
        'υ',
        'φ',
        'χ',
        'ψ',
        'ω',
    ],
    es: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'ñ',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    fa: [
        'ا',
        'ب',
        'پ',
        'ت',
        'ث',
        'ج',
        'چ',
        'ح',
        'خ',
        'د',
        'ذ',
        'ر',
        'ز',
        'ژ',
        'س',
        'ش',
        'ص',
        'ض',
        'ط',
        'ظ',
        'ع',
        'غ',
        'ف',
        'ق',
        'ک',
        'گ',
        'ل',
        'م',
        'ن',
        'و',
        'ه',
        'ی',
    ],
    fi: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'å',
        'ä',
        'ö',
    ],
    fr: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    he: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ', 'ק', 'ר', 'ש', 'ת'],
    hr: [
        'a',
        'b',
        'c',
        'č',
        'ć',
        'd',
        'dž',
        'đ',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'lj',
        'm',
        'n',
        'nj',
        'o',
        'p',
        'r',
        's',
        'š',
        't',
        'u',
        'v',
        'z',
        'ž',
    ],
    hu: [
        'a',
        'á',
        'b',
        'c',
        'cs',
        'd',
        'dz',
        'dzs',
        'e',
        'é',
        'f',
        'g',
        'gy',
        'h',
        'i',
        'í',
        'j',
        'k',
        'l',
        'ly',
        'm',
        'n',
        'ny',
        'o',
        'ó',
        'ö',
        'ő',
        'p',
        'r',
        's',
        'sz',
        't',
        'ty',
        'u',
        'ú',
        'ü',
        'ű',
        'v',
        'z',
        'zs',
    ],
    id: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    it: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'z'],
    ja: ['あ', 'か', 'さ', 'た', 'な', 'は', 'ま', 'や', 'ら', 'わ'],
    ka: [
        'ა',
        'ბ',
        'გ',
        'დ',
        'ე',
        'ვ',
        'ზ',
        'თ',
        'ი',
        'კ',
        'ლ',
        'მ',
        'ნ',
        'ო',
        'პ',
        'ჟ',
        'რ',
        'ს',
        'ტ',
        'უ',
        'ფ',
        'ქ',
        'ღ',
        'ყ',
        'შ',
        'ჩ',
        'ც',
        'ძ',
        'წ',
        'ჭ',
        'ხ',
        'ჯ',
        'ჰ',
    ],
    ko: ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'],
    lt: [
        'a',
        'ą',
        'b',
        'c',
        'č',
        'd',
        'e',
        'ę',
        'ė',
        'f',
        'g',
        'h',
        'i',
        'į',
        'y',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'r',
        's',
        'š',
        't',
        'u',
        'ų',
        'ū',
        'v',
        'z',
        'ž',
    ],
    lv: [
        'a',
        'ā',
        'b',
        'c',
        'č',
        'd',
        'e',
        'ē',
        'f',
        'g',
        'ģ',
        'h',
        'i',
        'ī',
        'j',
        'k',
        'ķ',
        'l',
        'ļ',
        'm',
        'n',
        'ņ',
        'o',
        'p',
        'r',
        's',
        'š',
        't',
        'u',
        'ū',
        'v',
        'z',
        'ž',
    ],
    me: [
        'a',
        'b',
        'c',
        'č',
        'ć',
        'd',
        'dž',
        'đ',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'lj',
        'm',
        'n',
        'nj',
        'o',
        'p',
        'r',
        's',
        'ś',
        'š',
        't',
        'u',
        'v',
        'z',
        'ź',
        'ž',
    ],
    mk: [
        'а',
        'б',
        'в',
        'г',
        'д',
        'ѓ',
        'е',
        'ж',
        'з',
        'ѕ',
        'и',
        'ј',
        'к',
        'л',
        'љ',
        'м',
        'н',
        'њ',
        'о',
        'п',
        'р',
        'с',
        'т',
        'ќ',
        'у',
        'ф',
        'х',
        'ц',
        'ч',
        'џ',
        'ш',
    ],
    nl: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    no: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'æ',
        'ø',
        'å',
    ],
    pl: [
        'a',
        'ą',
        'b',
        'c',
        'ć',
        'd',
        'e',
        'ę',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'ł',
        'm',
        'n',
        'ń',
        'o',
        'ó',
        'p',
        'r',
        's',
        'ś',
        't',
        'u',
        'w',
        'y',
        'z',
        'ź',
        'ż',
    ],
    pt: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    ro: [
        'a',
        'ă',
        'â',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'î',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        'ș',
        't',
        'ț',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ],
    sk: [
        'a',
        'á',
        'ä',
        'b',
        'c',
        'č',
        'd',
        'ď',
        'dz',
        'dž',
        'e',
        'é',
        'f',
        'g',
        'h',
        'ch',
        'i',
        'í',
        'j',
        'k',
        'l',
        'ĺ',
        'ľ',
        'm',
        'n',
        'ň',
        'o',
        'ó',
        'ô',
        'p',
        'q',
        'r',
        'ŕ',
        's',
        'š',
        't',
        'ť',
        'u',
        'ú',
        'v',
        'w',
        'x',
        'y',
        'ý',
        'z',
        'ž',
    ],
    sl: [
        'a',
        'b',
        'c',
        'č',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        'š',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'ž',
    ],
    sq: [
        'a',
        'b',
        'c',
        'ç',
        'd',
        'dh',
        'e',
        'ë',
        'f',
        'g',
        'gj',
        'h',
        'i',
        'j',
        'k',
        'l',
        'll',
        'm',
        'n',
        'nj',
        'o',
        'p',
        'q',
        'r',
        'rr',
        's',
        'sh',
        't',
        'th',
        'u',
        'v',
        'x',
        'xh',
        'y',
        'z',
        'zh',
    ],
    sr: [
        'а',
        'б',
        'в',
        'г',
        'д',
        'ђ',
        'е',
        'ж',
        'з',
        'и',
        'ј',
        'к',
        'л',
        'љ',
        'м',
        'н',
        'њ',
        'о',
        'п',
        'р',
        'с',
        'т',
        'ћ',
        'у',
        'ф',
        'х',
        'ц',
        'ч',
        'џ',
        'ш',
    ],
    srl: [
        'a',
        'b',
        'c',
        'č',
        'ć',
        'd',
        'dž',
        'đ',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'lj',
        'm',
        'n',
        'nj',
        'o',
        'p',
        'r',
        's',
        'š',
        't',
        'u',
        'v',
        'z',
        'ž',
    ],
    sv: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'å',
        'ä',
        'ö',
    ],
    th: [
        'ก',
        'ข',
        'ค',
        'ง',
        'จ',
        'ฉ',
        'ช',
        'ซ',
        'ญ',
        'ด',
        'ต',
        'ถ',
        'ท',
        'น',
        'บ',
        'ป',
        'ผ',
        'ฝ',
        'พ',
        'ฟ',
        'ม',
        'ย',
        'ร',
        'ล',
        'ว',
        'ศ',
        'ส',
        'ห',
        'อ',
        'ฮ',
    ],
    uk: [
        'а',
        'б',
        'в',
        'г',
        'ґ',
        'д',
        'е',
        'є',
        'ж',
        'з',
        'и',
        'і',
        'ї',
        'й',
        'к',
        'л',
        'м',
        'н',
        'о',
        'п',
        'р',
        'с',
        'т',
        'у',
        'ф',
        'х',
        'ц',
        'ч',
        'ш',
        'щ',
        'ь',
        'ю',
        'я',
    ],
    vi: [
        'a',
        'ă',
        'â',
        'b',
        'c',
        'd',
        'đ',
        'e',
        'ê',
        'g',
        'h',
        'i',
        'k',
        'l',
        'm',
        'n',
        'o',
        'ô',
        'ơ',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'ư',
        'v',
        'x',
        'y',
    ],
    zh: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'w',
        'x',
        'y',
        'z',
    ],
    zht: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'w',
        'x',
        'y',
        'z',
    ],
};
